module.exports = __webpack_public_path__ + "assets/img/背景备份-min.1b529ce7.png";